if(typeof hotspot_controller == 'undefined'){
    var hotspot_controller = {
        selector: '.hotspot-column',
        instances: {},
        hotspot_template: `
            <figure class="hotspot">
                <hotspot></hotspot>
                <div class="card closed">
                    <div class="body">Body Content</div>
                </div>
            </figure>
        `,
        init: function(){
            var self = this;
            jQuery(self.selector).each(function(){
                var $this = jQuery(this);
                var id = $this.attr('id');
                self.compressed_data = $this.data('hotspot-data');
                if(typeof self.compressed_data == 'undefined') return;
                self.original_data = window.atob($this.data('hotspot-data'));
                var instance = {
                    data: JSON.parse(window.atob($this.data('hotspot-data'))),
                    $object: $this,
                    window_width: jQuery(window).width(),
                };

                var $viewport = $this.find('.hotspot-image__container');

                instance.resize = function(){
                    //var instance = this;
                    //console.log('resizing', instance);

                    instance.$object.find('.hotspot').remove();

                    //console.log(instance.data);
                    for(var i = 0; i < instance.data.hotspots.length; i++){
                        var data = instance.data;
                        var hotspot = data.hotspots[i];
                        if(typeof data.viewport_width != 'undefined'){
                            //console.log('before', hotspot);
        
                            hotspot = hotspot_controller.correct_hotspot_for_viewport(hotspot, data.viewport_width, instance);
                            //console.log('corrected', hotspot);
                        }
                        if(hotspot.card_title == 'Title'){
                            continue;
                        }
                        if(hotspot.card_title.search('&amp;trade;') != -1){
                            hotspot.card_title = hotspot.card_title.replace('&amp;trade;', '&trade;');
                        }
                        if(typeof hotspot.hotspot_coords == 'undefined') hotspot.hotspot_coords = {left: 0, top: 0};
                        //hotspot.card_coords.left = hotspot.card_coords.left * -1;
                        var $hotspot = jQuery(hotspot_controller.hotspot_template);
                        $viewport.append($hotspot);
                        //$hotspot.find('hotspot').css(hotspot.hotspot_coords);
                        $hotspot.find('.card').css(hotspot.card_coords);
                        // $hotspot.find('header span').html(hotspot.card_title);
                        $hotspot.find('.body').html(`
                            <div class="hotspot-hover-content">
                                <div class="hotspot-hover-content__image">
                                    <img src="${hotspot.card_image}" />
                                </div>
                                <div class="hotspot-hover-content__text">
                                    <h6 class="hotspot-hover-content__title">${decodeURIComponent(hotspot.card_title)}</h6>
                                    <span class="snippet">${decodeURIComponent(hotspot.card_body)}</span>
                                </div>
                            </div>
                        `);

                        if(hotspot.card_coords.left < 0){
                            $hotspot.find('.card').removeClass('closed').addClass('is-active');
                            var width = $hotspot.find('.card').width() + 30;
                            $hotspot.find('.card').removeClass('is-active').addClass('closed');
                            if(hotspot.card_coords.left > (width * -1)){
                                hotspot.card_coords.left = hotspot.card_coords.left - width;
                                $hotspot.find('.card').css(hotspot.card_coords);
                            }
                        }
                        $hotspot.css(hotspot.figure_coords);
                        $hotspot.on('mouseenter', function(){
                            $card = jQuery(this).find('.card');
                            $container = jQuery(this).closest('.hotspot-column');
                            jQuery('body').addClass('hotspot-active');
                            $container.addClass('is-active');

                            if($card.hasClass('closed')){
                                instance.$object.addClass('is-active');
                                $card.removeClass('closed');
                            }
                        });

                        $hotspot.on('mouseleave', function(){
                            $card = jQuery(this).find('.card');
                            jQuery('body').removeClass('hotspot-active');

                            instance.$object.removeClass('is-active');
                            $card.addClass('closed');
                        });

                        hotspot_controller.render_lines($hotspot);
                    }
                    instance.data.viewport_width = $viewport.width();
                };

                instance.resize();

                jQuery(window).on('resize', function(){
                    if(jQuery(window).width() != instance.window_width){
                        instance.window_width = jQuery(window).width();
                        instance.resize();
                    }
                });

                $this.find('.mobile-hotspot-cards .card').click(function(){
                    var $card = jQuery(this);
                    if(!$card.hasClass('active')){
                        $this.find('.mobile-hotspot-cards .card').removeClass('active');
                        $this.find('.hotspot hotspot').removeClass('active');
                        $card.addClass('active');
                        var index = $this.find('.mobile-hotspot-cards .card').index(this);
                        var $linked_hotspot = $this.find('.hotspot hotspot').eq(index);
                        $linked_hotspot.addClass('active');
                        var window_height = jQuery(window).height();
                        var half = window_height / 2;
                        jQuery('html, body').animate({
                            scrollTop: $linked_hotspot.offset().top - half
                        }, 500);
                    }
                });

                hotspot_controller.instances[id] = instance;
            });
        },
        b64_to_utf8: function(str) {
            return decodeURIComponent(escape(window.atob(str)));
        },
        correct_measure_for_viewport: function(measure, orig_viewport, instance){
            var viewport = instance.$object.find('.hotspot-image__container');
            var viewport_width = viewport.width();


            var ratio = viewport_width / orig_viewport;
            //console.log('ratio', ratio);

            return measure * ratio;
        },
        correct_hotspot_for_viewport: function(hotspot, orig_viewport, instance){
            hotspot.card_coords.left = hotspot_controller.correct_measure_for_viewport(hotspot.card_coords.left, orig_viewport, instance);
            hotspot.card_coords.top = hotspot_controller.correct_measure_for_viewport(hotspot.card_coords.top, orig_viewport, instance);
            hotspot.figure_coords.left = hotspot_controller.correct_measure_for_viewport(hotspot.figure_coords.left, orig_viewport, instance);
            hotspot.figure_coords.top = hotspot_controller.correct_measure_for_viewport(hotspot.figure_coords.top, orig_viewport, instance);
            return hotspot;
        },
        render_lines: function(figure){

            //This logic needs to be reworked, only works for the bottom left quadrant
            //Probably need quadrant detection and different logic for each quadrant
            var $figure = jQuery(figure);
            var $hotspot = $figure.find('hotspot');
            var hotspot_coords = $hotspot.position();
            hotspot_coords.left += ($hotspot.width() / 2) - (3 / 2);
            hotspot_coords.top += ($hotspot.width() / 2) - (3 / 2);
            var $card = $figure.find('.card');
            var card_coords = $card.position();
            var orig_card_coords = card_coords;
            var card_width = $card.width();
            card_coords.left += $card.width() / 2;
            card_coords.top += 12 + ($hotspot.height() / 2);

            var x_run = Math.abs(card_coords.left - hotspot_coords.left) + 3; //3 is the width of the line
            var y_run = Math.abs(card_coords.top - hotspot_coords.top);

            if(
                hotspot_coords.left > orig_card_coords.left
                && hotspot_coords.left < orig_card_coords.left + card_width
            ){
                x_run = 0;
                card_coords.left = hotspot_coords.left;
            }

            //$figure.find('.line').remove();

            if(y_run > 0){
                var line = jQuery('<div class="line vertical"></div>').css('height', Math.abs(y_run) + 'px');
                line.css('width', '3px');
                if(hotspot_coords.top < card_coords.top){
                    line.css('top', hotspot_coords.top + 'px');
                    if(hotspot_coords.left < card_coords.left){
                        //Bottom Right
                        line.css('left',card_coords.left + 'px');
                    }else{
                        //Bottom left
                        line.css('left', card_coords.left + 'px');
                    }
                }else{
                    line.css('top', card_coords.top + 'px');
                    if(hotspot_coords.left < card_coords.left){
                        //Top Right
                        line.css('left',card_coords.left + 'px');
                    }else{
                        //Top Left
                        line.css('left', card_coords.left + 'px');
                    }
                }
               
                $figure.append(line);
            }
            if(x_run > 0){
                var line2 = jQuery('<div class="line horizontal"></div>').css('width', Math.abs(x_run) + 'px');
                line2.css('height', '3px');
                if(hotspot_coords.left < card_coords.left){
                    line2.css('left', hotspot_coords.left + 'px');
                    if(hotspot_coords.top < card_coords.top){
                        //Bottom Right
                        line2.css('top', hotspot_coords.top + 'px');
                    }else{
                        //Top Right
                        line2.css('top', hotspot_coords.top + 'px');
                    }
                }else{
                    line2.css('left', card_coords.left + 'px');
                    if(hotspot_coords.top < card_coords.top){
                        //Bottom Left
                        line2.css('top', hotspot_coords.top + 'px');
                    }else{
                        //Top Left
                        line2.css('top', hotspot_coords.top + 'px');
                    }
                }
                $figure.append(line2);
            }

        },
    };

    window.hotspot_controller = hotspot_controller;

    jQuery(document).ready(function(){
        hotspot_controller.init();
    });
}
